import { HeaderBarMessageHeaderInfo } from '../header-bar-message/header-bar-message.model';

/**
 * Header bar progress types
 */
export enum ProgressMessageType {
    Progress,
    Done,
    Warning,
};

/**
 * Icons that represent the header bar message type
 */
export const ProgressTypeIcons: string[] = [
    "",                                          // Progress - No icon displayed for this type
    "assets/images/notification_success24.svg",  // Done
    "assets/images/notification_warning24.svg",  // Warning
];

/**
 * Delete Message Information
 */
class MessageInfo extends HeaderBarMessageHeaderInfo {
    /**
     * Message type
     */
    messageType: ProgressMessageType = ProgressMessageType.Progress;
    /**
     * Message Text
     */
    message: string = "";
    /**
     * Message Icon
     */
    icon: string = ProgressTypeIcons[this.messageType];

    constructor() {
        super();
    }

    clear(): void {
        this.messageType = ProgressMessageType.Progress;
        this.message = "";
        super.clear();
    }
}

export class ProgressMessageBarInfo extends MessageInfo {
    constructor(message: string, type: ProgressMessageType) {
        super();
        this.message = message;
        this.messageType = type;
        this.setInitState();
        this.setState(type);
    }
    clear(): void {
        super.clear();
    }

    private setInitState() {
        this.showCaretDown = true;
        this.showCaretUp = false;
        this.showClose = true;
        this.showIcon = false;
        this.showProgress = false;
        this.showStop = true;
    }

    setState(state: ProgressMessageType) {
        this.showProgress = state == ProgressMessageType.Progress;
        this.messageType = state;
    }

    setCompleteState(hasErrors: boolean, wereAnyCanceled: boolean, completeMessage: string) {
        //
        // Place header bar into final state
        //
        this.showClose = true;
        this.showIcon = true;
        this.showCaretUp = false;
        this.showCaretDown = false;
        this.isExpanded = false;

        if (hasErrors) {
            this.setState(ProgressMessageType.Warning);
            this.showCaretUp = false;
            this.isExpanded = true;
        } else if (wereAnyCanceled) {
            this.setState(ProgressMessageType.Done);
            this.showCaretUp = false;
            this.isExpanded = true;
        } else {
            this.setState(ProgressMessageType.Done);
            this.message = completeMessage;
        }

        this.icon = ProgressTypeIcons[this.messageType];
    }
}

